import * as RS from 'redux-saga'
import { GetUserDetails, GetUserPortalDetails, SetUserFavoriteCourse, RemoveUserFavoriteCourse, SetUserTopics, GetRefreshUserToken } from 'src/Entities/User/User.Saga';
import { GetActivityThemes } from 'src/Entities/ActivityTheme/ActivityTheme.Saga';
import { GetActivityById } from 'src/Entities/Activity/Activity.Saga';
import { webSetUserFavoriteAction } from 'src/Entities/User/User.Actions';
// import { onBootstrap } from 'src/Entities/Person/Person.Saga';


export default function* rootSaga() {
    yield RS.effects.all([
        GetUserDetails(),
        GetUserPortalDetails(),        
        GetActivityThemes(),
        GetActivityById(),       
        SetUserFavoriteCourse(), 
        RemoveUserFavoriteCourse(),
        SetUserTopics(),
        GetRefreshUserToken()
        ])
}


// WEBPACK FOOTER //
// ./src/Config/ConfigureSagas.ts